var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllumerLaVoitureFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#343738;}.cls-2{fill:none;}.cls-3{fill:#282a2b;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#4b4e4f;}.cls-6{fill:#3d4142;}.cls-7{fill:#5a5e60;}.cls-8{fill:#191b1c;}.cls-9{fill:#585e60;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#724e49;}.cls-12{fill:#d2d9db;}.cls-13{fill:#97675e;}.cls-14{fill:#20456e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2313.5 875 0 659.41 0.5 4 2264.95 4 2313.5 875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1831,1463c0,103-116.55,271-285,271s-315-141.55-315-310,161.55-303,330-303S1831,1311,1831,1463Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "allumer la voiture frame 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 1207,
    width: 3000,
    height: 1793
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2313.5 875 0 659.41 0.5 4 2264.95 4 2313.5 875"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2314 871 0.5 655.41 1 0 2265.45 0 2314 871"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2241,719s-282-201-575-216-382.32,30.46-427.66,19.23-107.55-140.1-107.55-140.1L2181,327l109,301Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M956.9,483.15S1774,577,1855,605s307,158,307,158l401,737s-70,262-106,315-49,106-107,115S648,1784,648,1784Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,440s317-9,415,101,88,189,88,189L252,871,.5,531.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2254,655s-365-282-974-194c0,0-132,43-236-249C1010,121,933,0,933,0H2196.82S2299,607,2254,655Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3000,1710s-621-286-711-385-204.89-241.94-230-334c0,0-56-157,0-184s132-55,150-104,48-375-44-703h835Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1331,1116s-95,6-103-18-15-308,0-316,183-21,191,23,25,294,2,303S1331,1116,1331,1116Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1250,895l76-71s-18-82,18-135,85-133,187-163,135,129,135,129,2,151-61,216-226,178-256,195C1297,1066,1206,1046,1250,895Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1,4C103,4,380,4,492.93,0H0V7.08C.33,6.05.67,5,1,4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M529.6,493.78c-5.09,33.55-39.26,232.52-138.1,262.72-108,33-191-63-224-99s-148-188-167-203v1233s93.35-263.16,159-293c88-40,128.19-6.39,144,3,32,19,38.69,52.7,42.84,83.35-92.06,257.67-212,479.93-346.34,649.22H0v552.3H0c425-272,783.63-869.59,910.44-1604.52,66.35-384.56,60.3-755-4.86-1077.85H493C520.74,150.24,533.52,316.86,529.6,493.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M493,0h0Z",
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1904,1442c18,181-189.55,298-358,298s-315-141.55-315-310,161.55-303,330-303S1883.15,1232.35,1904,1442Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1219,1364l223,82s-11-81,78-140c-30-30-166-141-166-141Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1568,1295l-101-178s197-51,249,0c-50,109-73,178-73,178S1616,1284,1568,1295Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1245,1560c38-16,207-60,207-60s81,59,140,53c-24,99-53,218-53,218S1291,1778,1245,1560Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1678.55,1435.24c0,44.66-42.24,97.76-79.65,97.76-61.66,0-121.9-36.71-121.9-98.36A111.64,111.64,0,0,1,1588.64,1323C1650.29,1323,1678.55,1373.59,1678.55,1435.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1643.55,1428a54.31,54.31,0,0,1-54.31,54.31c-30,0-65.17-24.32-65.17-54.31,0-37.41,21.72-64,64-64C1618,1364,1643.55,1398,1643.55,1428Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1596,2112c-7-5-184-72-158-206s111-265,111-265,79-202,143-188,208,101,208,101l-10,276Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1863,1489s-57-36-66-69.27c-27-10.73-89.36-37.18-89.36-37.18C1630.32,1444.22,1517,1517,1517,1517l19,46,247.12,161,.55-.77.23.15.32-.93L1878,1590v-78C1880,1499.36,1868.29,1490.71,1863,1489Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1597 1464 1551 1444 1551 1431 1603 1404 1650.5 1425.75 1597 1464"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1772 1656 1784 1724 1536 1563 1517 1517 1772 1656"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1878 1532 1772 1656 1784 1724 1878 1590 1878 1532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1426,2294l203-299s-22.69-235.27,80.66-289.64S1876,1638,1876,1638v-98s-82-85-73-126,31-57,47-59,234,127,234,127l-18,223s46,192,52,210-383.58,622.12-441.79,655.56S1426,2294,1426,2294Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M174,3000s1167-852,1197-847,438,236,500,512c0,0-273.16,312-320,335Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3378,1463",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllumerLaVoitureFrame2);
export default __webpack_public_path__ + "static/media/allumer-la-voiture-frame-2.d87a59863f4bf637521e02aa62ff2c7a.svg";
export { ForwardRef as ReactComponent };